import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="w-full border-t border-white/[0.08] mt-20"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p
          className="font-mono text-xs uppercase tracking-[0.35em] text-zinc-500"
          data-testid="footer-copyright"
        >
          // GRACE THE GEEK STUDIOS · WORLD TIME {currentYear}
        </p>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-zinc-500">
          BUILT FOR DISTRIBUTED TEAMS
        </p>
      </div>
    </footer>
  );
};

export default Footer;
